import {Check} from '@sparkware/app-utils';

export class CmsBannerId {
  constructor(private _componentID: number, private _templateID: number, private _fallbackFileName: string | null) {
  }

  isMatch(componentId: number, templateId: number): boolean {
    return this._areEqual(componentId, this.componentID)
        && this._areEqual(templateId, this.templateID);
  }

  private _areEqual(val1: any, val2: any): boolean {
    val1 = Check.isNullOrUndefined(val1) ? '' : val1.toString();
    val2 = Check.isNullOrUndefined(val2) ? '' : val2.toString();

    return val1 === val2;
  }

  get key(): string {
    return `${this.componentID}_${this.templateID}_${this._fallbackFileName ?? 'null'}`;
  }

  get componentID(): any {
    return this._componentID;
  }

  get templateID(): any {
    return this._templateID;
  }

  get fallbackFileName(): string {
    return this._fallbackFileName;
  }

  toString() {
    return `templateID: ${this.templateID}; componentID: ${this.componentID}`;
  }
}
